module.exports = __webpack_public_path__ + "img/quietHour.6319142c.gif";